import { loadOffers } from "../common/api";

const model = {
    name: 'offers',
    state: {
        currentId: '',
        byId: {}
    },
    reducers: {
        setCurrentId: ( state, payload ) => {
            return {
                ...state,
                currentId: payload.oid
            }
        },
        cdcInsert: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.oid]: { 
                        ...state.byId[payload.oid],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcModify: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.oid]: {
                        ...state.byId[payload.oid],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcRemove: ( state, payload ) => {
            const keys = Object.keys( state.byId ).filter( f => f !== payload.oid );
            let newObj = {};
            keys.forEach( k => newObj[k] = state.byId[k] );
            return {
                ...state,
                byId: newObj
            }
        },
        loadedOffers: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    ...payload
                }
            }
        }
    },
    effects: ( dispatch ) => ( {
        async loadOffers( { aid, uid } ) {
            const list = await loadOffers( aid, uid );
            let byId = {};
            list.forEach( r => byId[r.oid] = r );
            dispatch.offers.loadedOffers( byId );
        },
        insert( { oid, cdc } ) {
            dispatch.offers.cdcInsert( { oid, cdc } );
        },
        modify( { oid, cdc } ) {
            dispatch.offers.cdcModify( { oid, cdc } );
        },
        remove( { oid } ) {
            dispatch.offers.cdcRemove( { oid } );
        },
        setCurrent( { oid } ) {
            dispatch.offers.setCurrentId( { oid } );
        }
    } )
}

export default model;